(function() {
'use strict';

angular
    .module('TR')
    .service('marhabaService', marhabaService);

function marhabaService(searchUnitService, occupancyService, $http) {
    const url = '/api2/marhaba/';
    const promiseCache = {};

    const service = {
        getProductDetails,
        rehydrate,
        getMarhabaEnabledTerminals,
        sort: sortMarhabaResults,
        filter: filterMarhabaResults,
        adjustMarhabaOptions
    };

    function getProductDetails(searchId, productId) {
        return $http.post(`${url}details/get`, { AvailabilitySearchId: searchId, MarhabaQuoteId: productId }).then(function(res) {
            return res.data;
        });
    }

    function rehydrate(productId, searchId) {
        if (promiseCache[productId + searchId]) {
            return promiseCache[productId + searchId];
        }
        promiseCache[productId + searchId] = $http.post(`${url}details/getfromsession`, { DetailsSearchId: searchId }).then(function(res) {
            const details = res.data || {};
            const occupancy = occupancyService.reduceOccupancy();
            const validChildren = occupancy.ChildAges.filter(function(el) { return el >= 2; }).length;

            details.Date = searchUnitService.startDate(searchUnitService.marhaba);
            details.Terminal = searchUnitService.getTerminal();
            details.maxElements = occupancy.Adults + validChildren;

            return details;
        });
        return promiseCache[productId + searchId];
    }

    function getMarhabaEnabledTerminals(airports) {
        return $http.post(`${url}terminals/getforairports`, { CultureCode: TRPCONFIG.Domain.CultureCode, Airports: airports });
    }

    function sortMarhabaResults(a, b) {
        const type = a.Type > b.Type ? 1 : a.Type < b.Type ? -1 : 0;
        const price = a.AdultPrice > b.AdultPrice ? 1 : a.AdultPrice < b.AdultPrice ? -1 : 0;
        const name = sortMarhabaResultsName(a, b);
        return type || price || name;
    }

    function sortMarhabaResultsName(a, b) {
        const name = a.Name > b.Name ? 1 : a.Name < b.Name ? -1 : 0;
        return name;
    }

    function filterMarhabaResults(item) {
        const isLounge = item.Type === 5;
        const isFree = item.AdultPrice === 0;
        if (!isLounge || (isLounge && !isFree)) {
            return item;
        }
    }

    function adjustMarhabaOptions(productInfo, defaultChauffeurName) {
        const result = {};

        if (productInfo.Details.AvailableOptions.length === 0) {
            result.noOptions = true;
        } else {
            productInfo.Details.AvailableOptions
                .sort(sortMarhabaResults)
                .filter(filterMarhabaResults)
                .forEach(function(p) {
                    switch (p.Type) {
                        case 3:
                            result.auxillaryProducts = result.auxillaryProducts || [];
                            result.auxillaryProducts.push(p);
                            break;
                        case 4:
                            p.Num = 0;
                            result.chauffeurs = result.chauffeurs || [];
                            result.chauffeurs.push(p);
                            break;
                        case 5:
                            result.lounges = result.lounges || [];
                            result.lounges.push(p);
                    }
                });

            if (result.chauffeurs && result.chauffeurs.length > 0) {
                result.chauffeurs.sort(sortMarhabaResultsName);
                result.chauffeurs.unshift({ Id: 0, Name: defaultChauffeurName });
                result.selectedChauffeur = result.chauffeurs[0];
            }
        }

        return result;
    }

    return service;
}
})();
